import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47c4351c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-24" }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"50%"},
    src: "/static/img/ilustracoes/resultado-pesquisa.png"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-24" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-texto-descricao" }, "Nenhum dado encontrado.")
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  class: "ant-col ant-col-xs-18 ant-col-xl-18",
  style: {"padding-left":"4px"}
}
const _hoisted_6 = { class: "ss-texto-descricao" }
const _hoisted_7 = { class: "ant-col ant-col-xs-6 ant-col-xl-6 ss-div-valor" }
const _hoisted_8 = { class: "ss-texto-valor" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.props.widget.dados.length === 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.props.widget.dados, (dado) => {
        return (_openBlock(), _createElementBlock("div", {
          key: dado.codigo,
          class: "ant-row"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(dado.titulo), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(dado.valor, dado.casasDecimais)), 1)
          ])
        ]))
      }), 128))
}